import { RouteType } from "types/RouteType";
import FleetDriverManagementWizardStore from "./FleetDriverManagementWizardStore";

const FleetDriverManagementWizardRoute: RouteType = {
  name: "FleetDriverManagementWizard",
  path: "/workflows/fleet-driver-management",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Fleet & Driver Management",
      component: () => import("./FleetDriverManagementWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./FleetDriverManagementWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.fleetDriverManagementWizardStore) {
      rootStore.fleetDriverManagementWizardStore = new FleetDriverManagementWizardStore(
        rootStore
      );
    }
    await rootStore.fleetDriverManagementWizardStore.loadInitialData();
    return true;
  },
};

export default FleetDriverManagementWizardRoute;